import router from './router'
import { getUser } from '@/utils/auth'
import store from './store'

//登录状态过滤
const whiteList = ['login', 'pageList' , 'zcool' ,'pagePreview','/nsy-home/template-list', '/template-preview','operation','singleConsole','certificate']
//需要免密登录的页面
const loginRouter = ['transferPage','tool_site','flowInfo','enquiry','userCourse','zcool','certificate','pageList','singleConsole','template','zcool']

router.beforeEach( async (to, from , next) => {
	if(loginRouter.includes(to.name)){
		const token = to.query.token
		const storeUser = store.getters['user/userInfo']
		const cookieId = storeUser && storeUser.cookie ? storeUser.cookie : '0'
		if(token){
			await store.dispatch('user/authorizeLogin',{'token':to.query.token})
			next()
		}else if(storeUser && storeUser.token && cookieId.length <= 1 && !token ){
			await store.dispatch('user/authorizeLogin',{'token':storeUser.token})
			next()
		}
		next()
	}
	let hasUser = getUser()
	if (hasUser) {
		if(to.path === '/login') {
			next({ path: '/tool'})
		} else {
			next()
		}
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next()
		} else {
			next({ path: '/login' })
		}
	}
})
